// 출퇴근 빠른 필터 배지 (정상/지각/조퇴/퇴근미체크 — 다중 토글) — Phase 1-2 A4
import React from 'react';
import { ATTENDANCE_FILTER_DEFS } from './utils';

function hexToRgb(hex) {
  if (!hex || !hex.startsWith('#')) return '100,116,139';
  return `${parseInt(hex.slice(1, 3), 16)},${parseInt(hex.slice(3, 5), 16)},${parseInt(hex.slice(5, 7), 16)}`;
}

export function AttendanceStatusFilters({ activeFilters, onToggle, counts }) {
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', padding: '0 4px' }}>
      {ATTENDANCE_FILTER_DEFS.map((f) => {
        const active = activeFilters.includes(f.key);
        const count = counts[f.key] || 0;
        if (count === 0 && !active) return null;
        const rgb = hexToRgb(f.color);
        return (
          <button
            key={f.key}
            type="button"
            onClick={() => onToggle(f.key)}
            style={{
              padding: '4px 12px', borderRadius: 14, fontSize: 12, fontWeight: 600, cursor: 'pointer',
              ...(active
                ? { background: `rgba(${rgb},0.15)`, color: f.color, border: `1px solid rgba(${rgb},0.3)` }
                : { background: 'transparent', color: 'var(--text-sub)', border: '1px solid var(--border)', opacity: 0.7 }),
            }}
          >
            {f.label} {count}
          </button>
        );
      })}
    </div>
  );
}
